"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledRequestFullQAActions = exports.StyledRequestFullQAPaper = exports.StyledRequestFullQAPopper = void 0;
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledRequestFullQAPopper = (0, styled_components_1.default)(material_1.Popper) `
  z-index: 1300;
`;
exports.StyledRequestFullQAPaper = (0, styled_components_1.default)(material_1.Paper) `
  width: 360px;
  padding: ${({ theme }) => theme.spacing(2)};;
`;
exports.StyledRequestFullQAActions = styled_components_1.default.div `
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing(1)};
  margin-top: ${({ theme }) => theme.spacing(1.25)};
`;
